/**
 * Settings — theme, prices, pack opening options
 */
import { useState, useEffect } from 'react';

export default function SettingsView() {
  const [theme, setTheme] = useState(() => (typeof window === 'undefined'
    ? 'dark'
    : localStorage.getItem('riftbound_theme') || 'dark'));
  const [showPrices, setShowPrices] = useState(() => (typeof window === 'undefined'
    ? true
    : localStorage.getItem('riftbound_show_prices') !== 'false'));
  const [pricePeriod, setPricePeriod] = useState(() => (typeof window === 'undefined'
    ? '7'
    : localStorage.getItem('riftbound_price_period') || '7'));
  const [dramaticOpening, setDramaticOpening] = useState(() => (typeof window === 'undefined'
    ? false
    : localStorage.getItem('riftbound_dramatic_opening') === 'true'));

  const applyTheme = (v) => {
    setTheme(v);
    if (typeof window !== 'undefined') {
      localStorage.setItem('riftbound_theme', v);
      document.documentElement.setAttribute('data-theme', v);
    }
  };

  // Ensure theme attribute is applied on initial render
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }, [theme]);

  return (
    <div className="settings-view">
      <h1>Settings</h1>
      <section className="settings-section">
        <h2>Appearance</h2>
        <label>
          Theme:
          <select value={theme} onChange={(e) => applyTheme(e.target.value)} className="filter-select">
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </select>
        </label>
      </section>
      <section className="settings-section">
        <h2>Prices</h2>
        <label>
          <input
            type="checkbox"
            checked={showPrices}
            onChange={(e) => {
              setShowPrices(e.target.checked);
              if (typeof window !== 'undefined') {
                localStorage.setItem('riftbound_show_prices', String(e.target.checked));
              }
            }}
          />
          Show prices
        </label>
        <label>
          Price period:
          <select
            value={pricePeriod}
            onChange={(e) => {
              setPricePeriod(e.target.value);
              if (typeof window !== 'undefined') {
                localStorage.setItem('riftbound_price_period', e.target.value);
              }
            }}
            className="filter-select"
          >
            <option value="1">1 day</option>
            <option value="7">7 days</option>
            <option value="30">30 days</option>
          </select>
        </label>
      </section>
      <section className="settings-section">
        <h2>Pack Opening</h2>
        <label>
          <input
            type="checkbox"
            checked={dramaticOpening}
            onChange={(e) => {
              setDramaticOpening(e.target.checked);
              if (typeof window !== 'undefined') {
                localStorage.setItem('riftbound_dramatic_opening', String(e.target.checked));
              }
            }}
          />
          Dramatic opening
        </label>
      </section>
    </div>
  );
}
